import { render, staticRenderFns } from "./PhoneNumberEditModal.vue?vue&type=template&id=3e49a56a&scoped=true"
import script from "./PhoneNumberEditModal.vue?vue&type=script&lang=js"
export * from "./PhoneNumberEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49a56a",
  null
  
)

export default component.exports